"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _grid = require("@rebass/grid");
var _reactIntl = require("react-intl");
var _SummaryBar = _interopRequireDefault(require("./SummaryBar"));
var _TenantContext = require("../context/TenantContext");
var _TextButton = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/action/TextButton"));
var _router = require("next/router");
var _TitleWrapper = _interopRequireDefault(require("./designsystem/TitleWrapper"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var __jsx = _react.default.createElement;
const ReviewDone = ({
  orderItem,
  setLeftReview,
  isAnonymous,
  pushUrl,
  pathName,
  locale
}) => {
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const {
    push
  } = (0, _router.useRouter)();
  return __jsx(_grid.Flex, {
    flexDirection: ['column', null, 'row'],
    justifyContent: "space-between"
  }, __jsx(_grid.Box, {
    order: 1,
    mr: [null, null, 5, 8]
  }, __jsx(StyledTitleWrapper, {
    title: __jsx(_reactIntl.FormattedMessage, {
      id: "BSaBd+",
      defaultMessage: [{
        "type": 0,
        "value": "Bedankt voor je beoordeling"
      }]
    })
  }), __jsx(Description, null, __jsx(_reactIntl.FormattedMessage, {
    id: "+4q/aA",
    defaultMessage: [{
      "type": 0,
      "value": "We hebben je beoordeling gepubliceerd op de website. Je kunt deze "
    }, {
      "type": 1,
      "value": "here"
    }, {
      "type": 0,
      "value": " bekijken."
    }],
    values: {
      here:
      // we've left a review, shown a "thank you" part, so now we can show the review when the user wants to
      __jsx(_TextButton.default, {
        showBorderAlways: true,
        onClick: () => isAnonymous ? push(pushUrl, {
          pathname: pathName
        }) : setLeftReview(null)
      }, __jsx(_reactIntl.FormattedMessage, {
        id: "re8oEl",
        defaultMessage: [{
          "type": 0,
          "value": "hier"
        }]
      }))
    }
  }), __jsx("br", null), __jsx("br", null), __jsx(_reactIntl.FormattedMessage, {
    id: "2Sv62q",
    defaultMessage: [{
      "type": 0,
      "value": "We zien je graag in de toekomst terug op ons mooie eiland!"
    }]
  }), __jsx("br", null), __jsx("br", null), brandConfig?.surveyUrl?.[locale] && __jsx(_react.default.Fragment, null, __jsx("b", null, __jsx(_reactIntl.FormattedMessage, {
    id: "qn3cpn",
    defaultMessage: [{
      "type": 0,
      "value": "Win een weekend op Texel"
    }]
  })), __jsx("br", null), __jsx(_reactIntl.FormattedMessage, {
    id: "D5uWFo",
    defaultMessage: [{
      "type": 0,
      "value": "De ondernemers op het eiland willen hun dienstverlening graag continu verbeteren. Jouw mening over Texel als vakantiebestemming is daarbij heel belangrijk."
    }]
  }), __jsx("br", null), __jsx("br", null), __jsx(_reactIntl.FormattedMessage, {
    id: "fWWgx2",
    defaultMessage: [{
      "type": 0,
      "value": "Met het invullen van een korte enquête deel je jouw ervaringen tijdens je verblijf op het eiland. Bijvoorbeeld jouw ervaring met het aanbod en de service in de horeca, de winkels en de musea op Texel."
    }]
  }), __jsx("br", null), __jsx("br", null), __jsx(_reactIntl.FormattedMessage, {
    id: "gUJGDh",
    defaultMessage: [{
      "type": 0,
      "value": "Onder de inzenders verloten we jaarlijks op 1 december een verblijf op Texel (geldig in het volgende kalenderjaar) in de vorm van een cadeaubon van € 500, te besteden bij een telefonische boeking via VVV Texel"
    }]
  }), __jsx("br", null), __jsx("a", {
    href: brandConfig.surveyUrl[locale],
    target: "_blank",
    rel: "noreferrer"
  }, __jsx(_reactIntl.FormattedMessage, {
    id: "4c+w8z",
    defaultMessage: [{
      "type": 0,
      "value": "Jouw ervaringen op Texel"
    }]
  }))))), __jsx(_grid.Box, {
    order: 1,
    mb: 6,
    ml: [3, null, 4],
    width: "30%",
    className: "gt-m"
  }, __jsx(_SummaryBar.default, {
    data: orderItem,
    showOnMobile: true,
    hidePrices: true
  })));
};
var _default = exports.default = ReviewDone;
const StyledTitleWrapper = (0, _styledComponents.default)(_TitleWrapper.default).withConfig({
  displayName: "ReviewDone__StyledTitleWrapper",
  componentId: "kbp3d8-0"
})(["@media screen and (min-width:", "){text-align:unset;}"], ({
  theme
}) => theme.mediaQueries.s);
const Description = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "ReviewDone__Description",
  componentId: "kbp3d8-1"
})(["margin-top:1.9rem;@media screen and (min-width:", "){margin-top:2.7rem;}"], ({
  theme
}) => theme.mediaQueries.m);